<template>
  <div
    v-if="currentQuestionData"
    :class="[style.dropDownSurface, mobileVersion ? style.mobile : '']"
  >
    <input
      :placeholder="'Подсказка'"
      :value="currentQuestionData.placeholder"
      @input="setPlaceholder"
      :class="style.input"
    />
    <span>Варианты</span>
    <TransitionGroupFromTop>
      <InputButtonElementQuestion
        v-for="(variant, index) in currentVariants"
        :variant="variant"
        :index="index"
        :deleteFunction="deleteVariant"
        :setTextFunction="setVariantText"
        :key="getVariantKey(variant, index)"
      />
    </TransitionGroupFromTop>
    <ButtonAdd
      :text="'Добавить'"
      :style="{width: 'fit-content'}"
      @click="addVariant"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./DropDown.module.scss";
import ButtonAdd from "@/elements/buttonAdd/ButtonAdd.vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import InputButtonElementQuestion from "@/elements/quizElements/InputButtonElementQuestion/InputButtonElementQuestion.vue";
import TransitionGroupFromTop from "@/dynamics/transitions/TransitionGroupFromTop/TransitionGroupFromTop.vue";
import {questions, QuestionVariant} from "@/page/quiz/typeQuiz";

export default defineComponent({
  name: "DropDown",
  components: {TransitionGroupFromTop, InputButtonElementQuestion, ButtonAdd},
  data() {
    return {
      style,
      modifyQuiz,
      variantKeyMap: new WeakMap<QuestionVariant, string>()
    };
  },
  methods: {
    createVariantKey(index: number): string {
      return `dropdown_variant_${this.selectedQuestion}_${index}_${Date.now()}_${Math.random()
        .toString(16)
        .slice(2)}`;
    },

    getVariantKey(variant: QuestionVariant, index: number): string {
      if (variant._key) {
        return variant._key;
      }

      const existingKey = this.variantKeyMap.get(variant);

      if (existingKey) {
        return existingKey;
      }

      const newKey = this.createVariantKey(index);
      this.variantKeyMap.set(variant, newKey);

      return newKey;
    },

    deleteVariant(index: number): void {
      this.currentQuestionData?.variants?.splice(index, 1);
    },

    addVariant(): void {
      if (!this.currentQuestionData) {
        return;
      }

      if (!Array.isArray(this.currentQuestionData.variants)) {
        this.currentQuestionData.variants = [];
      }

      this.currentQuestionData.variants.push({
        img: "",
        text: ""
      });
    },

    setVariantText(event: InputEvent, index: number): void {
      const target = event?.target as HTMLInputElement;
      const variant = this.currentVariants[index];

      if (!variant) {
        return;
      }

      variant.text = target.value;
    },

    setPlaceholder(event: Event): void {
      const target = event?.target as HTMLInputElement;
      if (!this.currentQuestionData) {
        return;
      }

      this.currentQuestionData.placeholder = target.value;
    }
  },
  computed: {
    quiz() {
      return this.$quizStore.getQuiz;
    },
    selectedQuestion() {
      return this.$quizStore.getSelectedQuestion;
    },
    selectedVersion() {
      return this.$quizStore.getSelectedVersion;
    },
    mobileVersion() {
      return this.selectedVersion === "Мобильная";
    },
    currentQuestionData(): questions | null {
      if (!this.quiz?.questions || this.selectedQuestion < 0) {
        return null;
      }

      return this.quiz.questions[this.selectedQuestion] || null;
    },
    currentVariants(): QuestionVariant[] {
      if (!Array.isArray(this.currentQuestionData?.variants)) {
        return [];
      }

      return this.currentQuestionData.variants;
    }
  }
});
</script>
